module.exports = __webpack_public_path__ + "static/img/QLD-18.efae35d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/QLD-18.jpg
// module id = A3B4
// module chunks = 0